import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AddPayerModal } from "@features/AddPayerModal/AddPayerModal";
import { useModalStore } from "@store/modal/modal";
import { useOverviewQuery } from "@services/overview/queries";

export const useAddPayerModal = () => {
  const { create } = useModalStore();
  const { data: overview } = useOverviewQuery();
  const { t } = useTranslation();

  const openAddPayerModal = () => {
    if (!overview) {
      return;
    }

    const availableJbs = overview?.jointBillServices.filter(
      (jbs) => jbs.isOwner,
    );

    if (availableJbs.length === 0) {
      toast.error(t("addPayerModal.toast.addPayerUnavailable"));
      return;
    }

    create((modalProps) => <AddPayerModal {...modalProps} />);
  };

  return { openAddPayerModal };
};
